import Row from './row';
import Col from './col';
export { Row, Col };


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/grid/index.js
// module id = 168
// module chunks = 14